<template>
    <div>
        <div v-html="content" />
    </div>
</template>
<script>
export default {
    computed: {
        content() {
            let content = this.$root.interactiveInterface.congratulation_message;

            content = content.replaceAll('{user}', this.$root.user.nickname);
            content = content.replaceAll('{email}', this.$root.user.email);
            content = content.replaceAll('{finishTime}', this.$root.user.fill_time);
            content = content.replaceAll('{point}', this.$root.user.points);
            content = content.replaceAll('{maxPoint}', this.$root.user.max_task_point);
            content = content.replaceAll('{checkButton}', this.generateCheckButton());

            return content;
        }
    },
    methods: {
        generateCheckButton() {
            return `
                <div class="row">
                    <div class="col-12">
                        <a
                            href="${this.$root.getUrlPrefix()}/${this.$root.user.fingerprint}/check"
                            class="btn btn-primary"
                            @click.prevent="navigateToCheck"
                        >
                            Feladatok ellenőrzése
                        </a>
                    </div>
                </div>
            `;
        }
    }
}
</script>
